import { render, staticRenderFns } from "./ProjectShortcuts.vue?vue&type=template&id=42c00b8a"
import script from "./ProjectShortcuts.vue?vue&type=script&lang=ts"
export * from "./ProjectShortcuts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports